import { useCallback, useEffect, useState } from "react";
import { api, errDetail, fmtEur, fmtDate } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { AlertTriangle } from "lucide-react";

export default function InvoiceExceptions() {
  const [rows, setRows] = useState([]);
  const [caps, setCaps] = useState([]);
  const [resolveFor, setResolveFor] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => { api.get("/srm/invoices?status=exception").then((r) => setRows(r.data || [])).catch((e) => toast.error(errDetail(e))); }, []);
  useEffect(() => { api.get("/srm/my-caps").then((r) => setCaps(r.data.caps || [])).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);
  const canResolve = caps.includes("po_approve") || caps.includes("srm_admin");
  const resolve = async () => {
    setBusy(true);
    try { await api.post(`/srm/invoices/${resolveFor.id}/resolve`, { note }); toast.success("Rechnung freigegeben (gebucht)"); setResolveFor(null); setNote(""); load(); }
    catch (e) { toast.error(errDetail(e)); } finally { setBusy(false); }
  };
  return (
    <div className="p-6 max-w-[1300px] mx-auto" data-testid="invoice-exceptions-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-11 w-11 rounded-xl bg-red-600 flex items-center justify-center"><AlertTriangle className="h-5 w-5 text-white" /></div>
        <div><h1 className="text-2xl font-bold text-[#1B2A4A]">Ausnahme-Queue (3-Way-Match)</h1><p className="text-sm text-gray-500">Rechnungen mit Preis-/Mengenabweichung</p></div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Rechnung</TableHead><TableHead>Bestellung</TableHead><TableHead>Lieferant</TableHead><TableHead>Betrag</TableHead><TableHead>Abweichungen</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-gray-400 py-8">Keine offenen Ausnahmen</TableCell></TableRow>}
            {rows.map((r) => (
              <TableRow key={r.id} data-testid={`invex-row-${r.invoice_number}`}>
                <TableCell className="font-mono">{r.invoice_number}</TableCell><TableCell className="font-mono">{r.po_number}</TableCell>
                <TableCell>{r.supplier_name}</TableCell><TableCell>{fmtEur(r.amount, r.currency)}</TableCell>
                <TableCell className="text-xs text-red-700">{(r.match_result?.exceptions || []).map((e, i) => <div key={i}>{(e.reasons || []).join("; ")}</div>)}</TableCell>
                <TableCell>{canResolve && <Button size="sm" variant="outline" data-testid={`invex-resolve-${r.invoice_number}`} onClick={() => setResolveFor(r)}>Freigeben</Button>}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <Dialog open={!!resolveFor} onOpenChange={() => setResolveFor(null)}>
        <DialogContent data-testid="invex-resolve-dialog">
          <DialogHeader><DialogTitle>Rechnungsausnahme freigeben</DialogTitle><DialogDescription>Wird protokolliert (audit) und anschließend an das ERP übergeben.</DialogDescription></DialogHeader>
          <div><Label>Begründung *</Label><Textarea data-testid="invex-note" value={note} onChange={(e) => setNote(e.target.value)} /></div>
          <DialogFooter><Button variant="outline" onClick={() => setResolveFor(null)}>Abbrechen</Button>
            <Button data-testid="invex-resolve-save" disabled={busy || !note} className="bg-[#1B2A4A] hover:bg-[#24365d]" onClick={resolve}>Freigeben & buchen</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
